import { isExternalRouter } from 'auth/cognito';
import { useRef, useState } from 'react';
import { Button, FlexboxGrid, Input, Panel } from 'rsuite';

export default function AddCertification({
    addCertification,
}: {
    addCertification: (issuer: string, name: string, imgBase64str?: string) => void;
}) {
    const [issuer, setIssuer] = useState('');
    const [name, setName] = useState('');
    const [imgBase64Str, setImgBase64Str] = useState('');

    const processImage = () => {
        const file = inputRef.current?.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = () => {
            const base64String = reader.result as string;
            setImgBase64Str(base64String);
        };

        reader.onerror = error => {
            console.error('Error reading file:', error);
        };

        reader.readAsDataURL(file);
    };

    const inputRef = useRef<HTMLInputElement>(null);

    return (
        <FlexboxGrid.Item>
            <Panel
                shaded
                style={{
                    width: 300,
                    height: 320,
                    margin: 10,
                    opacity: 1,
                    position: 'relative',
                }}
                header={
                    <FlexboxGrid justify="center">
                        <h5>Add New</h5>
                    </FlexboxGrid>
                }
            >
                <FlexboxGrid justify="center">
                    <FlexboxGrid.Item colspan={3}></FlexboxGrid.Item>
                    <FlexboxGrid.Item colspan={15}>
                        Issuer <Input title="Issuer" value={issuer} onChange={setIssuer} />
                        Name <Input title="Name" value={name} onChange={setName} />
                        {!isExternalRouter && (
                            <>
                                Image
                                <input
                                    title="Image"
                                    ref={inputRef}
                                    type="file"
                                    onChange={() => processImage()}
                                />
                            </>
                        )}
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item colspan={3}></FlexboxGrid.Item>
                </FlexboxGrid>
                <FlexboxGrid justify="center" style={{ paddingTop: '1em' }}>
                    <Button
                        appearance="primary"
                        color="green"
                        onClick={() => {
                            addCertification(issuer, name, imgBase64Str);

                            if (inputRef.current) {
                                inputRef.current.value = '';
                            }
                            setName('');
                            setIssuer('');
                            setImgBase64Str('');
                        }}
                        disabled={name === ''}
                    >
                        Add
                    </Button>
                </FlexboxGrid>
            </Panel>
        </FlexboxGrid.Item>
    );
}
